import { Type } from "@sinclair/typebox";
import { IdSchema, Sha256Schema, TimestampSchema } from "./shared.js";
import { GuideDefinitionSchema } from "./guide.js";
export const GuideRunnerSchema = Type.Object({
    runnerId: IdSchema,
    ownerUserId: IdSchema,
    definitionId: GuideDefinitionSchema.properties.definitionId,
    contentDigest: Sha256Schema,
    createdAt: TimestampSchema,
    expiresAt: TimestampSchema,
    revokedAt: Type.Union([TimestampSchema, Type.Null()]),
    sessionId: Type.Union([IdSchema, Type.Null()]),
}, { additionalProperties: false });
export const GuideRunnerTokenBodySchema = Type.Object({
    runnerId: IdSchema,
    secret: Type.String({ pattern: "^grk_[A-Za-z0-9_-]{43}$" }),
}, { additionalProperties: false });
export const GuideRunnerTokenSchema = Type.Object({
    runner: GuideRunnerSchema,
    accessToken: Type.String({ pattern: "^grt_[A-Za-z0-9_-]{43}$" }),
    expiresAt: TimestampSchema,
}, { additionalProperties: false });
export const GuideRunnerCredentialSchema = Type.Object({
    kind: Type.Literal("guide-canary-runner"),
    ...GuideRunnerTokenBodySchema.properties,
}, { additionalProperties: false });
//# sourceMappingURL=guide-runner.js.map